/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import {BaseFieldEditor} from "./BaseFieldEditor";
import autobind from "autobind-decorator";
import MaskedFormControl from "../../../../../monitoring/src/Components/Common/MaskedInputControl";
import React from "react";

export class PhoneFieldEditor extends BaseFieldEditor {
	@autobind
	_render() {
		const {hasExtension = true} = this.getFieldDefCustomData();

		return <MaskedFormControl
			mask={`(111) 111-1111${hasExtension ? ' 1111' : ''}`}
			type="text"
			value={this.props.Value != null ? this.props.Value : ""}
			onChange={(x) => this.props.OnUpdate(x.target.value)}
		/>;
	}
}